import {
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useRef,
  useState,
} from "react";
import { Card, Grid, CardContent, Typography, Divider, Button, Dialog, DialogTitle, IconButton, DialogContent, Drawer, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Stack, Modal, Box, Switch, Autocomplete, TextField, Collapse } from "@mui/material";
import Chart from "react-google-charts";
import "./style.css";

import main1 from '../../assets/images/totaldoc.png';
import main2 from '../../assets/images/totalType.png';
import main3 from '../../assets/images/totalIndexFile.png';
import main4 from '../../assets/images/totalSplitFile.png';

import { PieChart } from '@mui/x-charts/PieChart';
import api from "../../utils/Url";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";



import { ListAlt, LocationOn, Home, CalendarToday, DoneAll, ElectricBolt } from '@mui/icons-material';
import PersonIcon from "@mui/icons-material/Person";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { format } from 'date-fns';
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { toast, ToastContainer } from "react-toastify";
import lightOn from "../../assets/images/Light_On.png";
import lightOff from "../../assets/images/Light_Off.png";
import { useFormik } from "formik";
import CustomLabel from "../../CustomLable";
import KeyboardArrowUpTwoToneIcon from "@mui/icons-material/KeyboardArrowUpTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ProgressBar from "@ramonak/react-progress-bar";






const containerStyle = {
  width: "100%",
  height: "450px",
};

export const options1 = {
  // title: "Weight of the vehicle",
  title: "My Daily Activities",
  pieHole: 0.4,
  is3D: false,
};




const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "85%",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};
interface Department {
  dept_id: number;
  dept_name: string;
  session_year: string;
  // Add other properties here
}


interface AnimatedCountProps {
  totalCount: number;
}

// AnimatedCount Component
const AnimatedCount: React.FC<AnimatedCountProps> = ({ totalCount }) => {
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (count < totalCount) {
      interval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount < totalCount) {
            return prevCount + 1;
          } else {
            clearInterval(interval);
            return totalCount;
          }
        });
      }, 50); // Adjust the speed here
    }
    return () => clearInterval(interval); // Cleanup on component unmount
  }, [count, totalCount]);

  return <span>{count}</span>;
};

export default function HomePage() {


  const [chartData, setChartData] = useState<any>([]);



  const [showModal1, setShowModal1] = useState(false);
  const { t } = useTranslation();



  const [vehicles, setVehicles] = useState<any>([]);
  const [activeVehicle, setActiveVehicle] = useState<any>(null);
  const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
  const mapRef: any = useRef(null);
  const [currentMap, setCurrentMap] = useState(false);



  // Fetch the vehicle data from API
  const MapData = async (Id: any) => {
    setCurrentMap(true);

    const result = await api.post(`PoleInstallation/GetPoleInstallation`, {
      poleInstId: Id,
      zoneId: -1,
      wardId: -1,
      "show": true,
      "exportOption": ""
    });
    const validItems = result?.data?.data[0]["poleInstalChild"];

    console.log("validItems", validItems);
    const arr = validItems.map((item: any, index: any) => ({
      lat: parseFloat(item?.latitute),
      lng: parseFloat(item?.longitute),
      id: index + 1,
      itemName: item?.itemName,
      empName: item?.empName,

      depth: item.depth,
      tracktime: format(item?.apprdate, 'dd-MM-yyyy'),
      poleno: item.poleno,
      zoneName: item?.zoneName,
      wardName: item.wardName ? `${item.wardName} (${item.wardNo})` : "_ _",

      icon: "https://cdn-icons-png.flaticon.com/512/209/209403.png",
    }));
    setVehicles(arr);
    setCenter(calculateCenter(arr));

    if (arr.length > 0) {
      adjustZoomLevel(arr);
    }
  };

  const calculateCenter = (vehicles: any) => {
    if (vehicles.length === 0) {
      return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
    }

    const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
    const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

    const avgLat =
      latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
    const avgLng =
      longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
      longitudes.length;

    return { lat: avgLat, lng: avgLng }; // Return the center point
  };

  // Adjust the zoom level based on the spread of the vehicles
  const adjustZoomLevel = (vehicles: any) => {
    const bounds = new window.google.maps.LatLngBounds();

    vehicles.forEach((vehicle: any) => {
      bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
    });

    if (mapRef.current) {
      mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
    }
  };

  const handleMarkerMouseOver = (vehicle: any) => {
    setActiveVehicle(vehicle);
  };

  const handleMarkerMouseOut = () => {
    setActiveVehicle(null);
  };






  const [TotalCount, setTotalCount] = useState(0);
  const [ComplainCount, setComplainCount] = useState(0);
  const [IssueCount, setIssueCount] = useState(0);
  const [deviceCount, setDeviceCount] = useState(0);
  const [DepartmentData, setDepartmentData] = useState<Department[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(null);

  const [zones5, setZones5] = useState<any>([]);
  const [columns5, setColumns5] = useState<any>([]);
  const [isLoading5, setIsLoading5] = useState(true);

  const [isModal1, setModal1] = useState(false);


  const [zones, setZones] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isModal, setModal] = useState(false);



  const [zones2, setZones2] = useState([]);
  const [columns2, setColumns2] = useState<any>([]);
  const [isLoading2, setIsLoading2] = useState(true);

  const [zones3, setZones3] = useState([]);
  const [columns3, setColumns3] = useState<any>([]);
  const [isLoading3, setIsLoading3] = useState(true);

  const [zones4, setZones4] = useState([]);
  const [columns4, setColumns4] = useState<any>([]);
  const [isLoading4, setIsLoading4] = useState(true);

  const [isModal2, setModal2] = useState(false);
  const [swipModal, setSwipModal] = useState(false);

  const [swipData, setSwipData] = useState<any>([]);


  const [swipModal1, setSwipModal1] = useState(false);

  const [swipData1, setSwipData1] = useState<any>([]);


  const [swipModal2, setSwipModal2] = useState(false);

  const [swipData2, setSwipData2] = useState<any>([]);



  const [isModal3, setModal3] = useState(false);

  const [isModal4, setModal4] = useState(false);





  const [isData, setData] = useState<any>([

  ]);



  const [zones6, setZones6] = useState<any>([]);
  const [columns6, setColumns6] = useState<any>([]);
  const [isLoading6, setIsLoading6] = useState(true);

  const [isModal6, setModal6] = useState(false);





  const [Option, setOption] = useState([
    { value: "-1", label: t("text.SelectZone") },
  ]);

  const [taxOption, setTaxOption] = useState([
    { value: "-1", label: t("text.SelectWard") },
  ]);

  const [Option1, setOption1] = useState([
    { value: "-1", label: t("text.SelectPole") },
  ]);


  const [IsEmp, setEmp] = useState([
    { value: "-1", label: t("text.SelectEmployee") },
  ]);

  const [IsStatus, setStatus] = useState([
    { value: "-1", label: t("text.Status") },
  ]);

  const [Iscomplaint, setComplaint] = useState([
    { value: "-1", label: t("text.SelectComplaintNo") },
  ]);


  const [IsIndentNo, setIndentNo] = useState([
    { value: "-1", label: t("text.SelectIndent") },
  ]);


  const [IsDeviceNo, setDeviceNo] = useState([
    { value: "-1", label: t("text.SelectDeviceNo") },
  ]);



  const [openCollaps, setopenCollaps] = useState(false);

  const [openCollaps1, setopenCollaps1] = useState(false);

  const [openCollaps2, setopenCollaps2] = useState(false);
  const [openCollaps3, setopenCollaps3] = useState(false);

  const [openCollaps4, setopenCollaps4] = useState(false);


  const [chartData1, setChartData1] = useState<any>([]);


  const [IsPending, setPending] = useState(0);
  const [IsProcceccing, setProccecing] = useState(0);

  const [IsComplete, setComplete] = useState(0);
  const [IsTotal, setTotal] = useState(0);








  const handleCollapse3 = () => {
    setopenCollaps3((prevOpen) => !prevOpen);
  };




  const handleCollapse = () => {
    setopenCollaps((prevOpen) => !prevOpen);
  };

  const handleCollapse1 = () => {
    setopenCollaps1((prevOpen) => !prevOpen);
  };


  const handleCollapse2 = () => {
    setopenCollaps2((prevOpen) => !prevOpen);
  };


  const handleCollapse4 = () => {
    setopenCollaps4((prevOpen) => !prevOpen);
  };









  useEffect(() => {

    getZone();
    getEmployee();
    getCompStatus();
    getComplaint();
    getIndent();
    getCompCount();
    getDeviceCount();
    getDeviceNo();




  }, []);


  const getDeviceCount = async () => {

    const res = await api.get(`Dashboard/TotalDeviceCount?DeviceId=-1`);
    const Data = res?.data

    setDeviceCount(Data?.totalCount);




  };



  const getCompCount = async () => {

    const res = await api.get(`Dashboard/GetPendingComplaintCount`);
    const Data = res?.data?.data

    const total = Number(Data?.pending) + Number(Data?.processing) + Number(Data?.complete)

    setComplete(Data?.complete);
    setPending(Data?.pending);
    setProccecing(Data?.processing)

    

    setTotal(total);

    //console.log('check Status',Data?.complete,Data?.pending,Data?.processing,total)




  };



  const options = {
    hAxis: {
      title: "Complaint Status", // x-axis title
    },
    vAxis: {
      title: "Count", // y-axis title
    },
    series: {

      1: { curveType: "function" }, // Smoothing applied to the second series (Processing)
    },
    legend: { position: "top" },
  };



  // const options = {
  //   hAxis: {
  //     title: "Time",
  //   },
  //   vAxis: {
  //     title: "Popularity",
  //   },
  //   series: {
  //     1: { curveType: "function" },
  //   },
  //   legend: { position: 'top' }
  // };


  const getZone = async () => {
    const collectData = {
      zoneID: -1,
      user_ID: "",
    };
    const res = await api.post(`Zone/GetZonemaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.zoneName,
        value: item.zoneID,
      })) || [];

    setOption(arr);
  };


  const getDeviceNo = async () => {
    const collectData = {
      "deviceId": -1,
      "deviceNo": "",
      "simNo": "",
      "simContactNo": "",
      "relayNo": "",
      "zoneId": -1,
      "wardId": -1,
      "poleId": -1,
    };
    const res = await api.post(`DeviceInstallation/GetDeviceInstallation`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.deviceNo,
        value: item.deviceId,
      })) || [];

    setDeviceNo(arr);
  };

  const getWardData = async (Id: any) => {
    const collectData = {
      areaID: -1,
      zoneID: Id
    };
    const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.areaName,
        value: item.areaID,
      })) || [];

    setTaxOption(arr);
  };


  const getPole = async (wardID: any) => {
    const collectData = {
      "poleInstId": -1,
      "zoneId": -1,
      "wardId": wardID
    };
    const res = await api.post(`PoleInstallation/GetPoleNoZoneWardWise`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.poleno,
        value: item.poleInstChildId,
      })) || [];

    setOption1(arr);
  };



  const getEmployee = async () => {
    const collectData = {
      "empid": -1, "userId": "", "empName": "", "empMobileNo": "", "empDesignationId": -1, "empDeptId": -1, "empStateId": -1, "empCountryID": -1, "empCityId": -1, "empPincode": 0, "roleId": ""
    };
    const res = await api.post(`EmpMaster/GetEmpmaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.empName,
        value: item.empid,
      })) || [];

    setEmp(arr);
  };


  const getCompStatus = async () => {
    const collectData = {
      "id": -1,

    };
    const res = await api.post(`statusmaster/GetStatusMaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.status,
        value: item.id,
      })) || [];

    setStatus(arr);
  };


  const getComplaint = async () => {
    const collectData = {
      "compId": -1,
      "empId": -1,
      "zoneid": -1,
      "wardid": -1,
      "compTypeId": -1,
      "complaintNo": "",
      "fromDate": null,
      "toDate": null,
      "compStatusId": -1,
      "show": true,
      "exportOption": ".pdf"
    };
    const res = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.complaintNo,
        value: item.compId,
      })) || [];

    setComplaint(arr);
  };


  const getIndent = async () => {
    const collectData = {
      "issueId": -1,
      "indentId": -1,
      "empId": -1,
      "fromDate": null,
      "toDate": null
    };
    const res = await api.post(`StaffItemIssue/GetItemIssue`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.indentNo || "_ _",
        value: item.indentId || 0,
      })) || [];

    setIndentNo(arr);
  };






  const getTableData = async (row: any) => {
    const collectData = {
      "lightInstId": row.lightInstId,
      "zoneId": row.zoneId || -1,
      "wordId": row.wordId || -1,
      "show": true,
      "exportOption": ""
    };
    const response = await api.post(`LightInstallation/GetLightInstallation`, collectData);
    const data = response.data.data;

    setData(data);
  };







  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    child: any,
    lightInstId: number
  ) => {
    const updatedStatus = event.target.checked ? true : false;


    const updatedChildren = zones5.map((zone: any) => {
      if (zone.lightInstId === lightInstId) {
        const updatedLightInstalChild = zone.children.map((item: any) => {
          if (item.lightInstallationId === child.lightInstallationId) {
            return { ...item, isOn: updatedStatus };
          }
          return item;
        });
        return { ...zone, children: updatedLightInstalChild };
      }
      return zone;
    });




    const collectData = {
      "lightInstId": isData[0]?.lightInstId || 0,
      "zoneId": isData[0]?.zoneId || 0,
      "wordId": isData[0]?.wordId || 0,
      "poleNo": isData[0]?.poleNo || "",
      "instDate": isData[0]?.instDate || "",
      "instBy": isData[0]?.instBy || 0,
      "apprBy": isData[0]?.apprBy || 0,
      "apprImg": isData[0]?.apprImg || "",
      "apprDate": isData[0]?.apprDate || "",
      "zoneName": isData[0]?.zoneName || "",
      "wardName": isData[0]?.wardName || "",
      "img": isData[0]?.img || "",
      "lightInstalChild": updatedChildren.find((z: any) => z.lightInstId === lightInstId)?.children || []

    };


    api.post(`LightInstallation/AddUpdateLightInstallation`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          zoneStatusData(parseInt(response.data.data));
          setTimeout(() => {
            setSwipData1(updatedChildren.find((z: any) => z.lightInstId === lightInstId)?.children);

          }, 200);

        } else {
          toast.error(response.data.mesg);
        }
      });
  };













  //console.log("check", TotalCount);

  const handleTotalCategoryClick = () => {
    // setShowModal1((prevState) => !prevState);
    setShowModal1(!showModal1);
  };


  const handleClose1 = () => {
    setModal1(false);
  };







  const fetchCompStatus = async (StatusId: any) => {
    setModal6(true);
    try {
      const collectData = {
        "compId": -1,
        "empId": -1,
        "zoneid": -1,
        "wardid": -1,
        "compTypeId": -1,
        "complaintNo": "",
        "fromDate": null,
        "toDate": null,
        "compStatusId": StatusId,
        "show": true,
        "exportOption": ".pdf"
      };
      const response = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
      const data = response.data.data;
      // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.compId,
        wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
      }));
      setZones6(zonesWithIds);
      setIsLoading6(false);

      if (data.length > 0) {
        const columns6: GridColDef[] = [


          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "compTypeName",
            headerName: t("text.ComplaintType"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "wardWithNumber",
            headerName: t("text.wardName"),
            flex: 1,
          },

          {
            field: "complaintDate",
            headerName: t("text.ComplaintDate"),
            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "empName",
            headerName: t("text.EmployeeName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "complaintNo",
            headerName: t("text.ComplaintNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "complaint",
            headerName: t("text.ComplaintDescription"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "compStatusName",
            headerName: t("text.ComplaintStatus"),
            flex: 1,

            headerClassName: "MuiDataGrid-colCell",
          },


        ];
        setColumns6(columns6 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns6 = columns6.map((column: any) => ({
    ...column,
  }));




  const zoneStatusData = async (zoneID: any) => {
    setModal1(true);
    try {

      const collectData = {
        "lightInstId": -1,
        "zoneId": zoneID,
        "wordId": formik.values.wordId1,
        "poleNo": formik.values.poleNo,
        "fromDate": formik.values.fromDate1,
        "toDate": formik.values.toDate1

      };


      const response = await api.post(
        `LightInstallation/GetLightSwitchOnOf`, collectData
      );
      const data = response.data.data;
      // setStatus(data[0]?.ignition);

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.lightInstId,
        wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _",
        children: zone.lightInstalChild || []
      }));
      setZones5(zonesWithIds);

      // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
      setIsLoading5(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [
          {
            field: "serialNo",
            headerName: (
              <>
                <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.SrNo")} {/* Serial number */}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 0.3,
          },
          {
            field: "zoneName",
            headerName: (
              <>
                <LocationOn
                  style={{ marginRight: 8, verticalAlign: "middle" }} // Zone icon (Location-based)
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.zoneName")} {/* Zone name */}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 1,
          },
          {
            field: "wardWithNumber",
            headerName: (
              <>
                <Home
                  style={{ marginRight: 8, verticalAlign: "middle" }} // Ward icon (Area or unit related to poles)
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.wardName")} {/* Ward name */}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 1,
          },
          {
            field: "instDate",
            headerName: (
              <>
                <CalendarToday
                  style={{ marginRight: 8, verticalAlign: "middle" }} // Installation date (Calendar icon)
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.InstallationDate")} {/* Installation date */}
                </span>
              </>
            ),
            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "apprDate",
            headerName: (
              <>
                <DoneAll
                  style={{ marginRight: 8, verticalAlign: "middle" }} // Approved date (Done icon)
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.ApprovedDate")} {/* Approved date */}
                </span>
              </>
            ),

            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
            cellClassName: "wrap-text",
            flex: 1,
          },
          {
            field: "poleNo",
            headerName: (
              <>
                <ElectricBolt
                  style={{ marginRight: 8, verticalAlign: "middle" }} // Pole number (Electric bolt icon, indicating poles)
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.PoleNo")} {/* Pole number */}
                </span>
              </>
            ),


            renderCell: (params) => {
              return (
                <div
                  style={{ cursor: 'pointer', color: "blue" }}
                  onClick={() => {
                    setSwipData1(params.row.lightInstalChild);

                    getTableData(params.row);
                    setSwipModal1(true)
                  }}
                >
                  {params.value}
                </div>
              );
            },
            flex: 1,
          },
        ];
        setColumns5(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns5 = columns5.map((column: any) => ({
    ...column,
  }));




  const getSwipDataPole = async (Id: any) => {
    setSwipModal(true);
    try {

      const collectData = {
        "poleInstId": Id, "zoneId": -1, "wardId": -1, "show": true, "exportOption": ""
      };


      const response = await api.post(
        `PoleInstallation/GetPoleInstallation`, collectData
      );
      const data = response.data.data[0]?.poleInstalChild;

      setSwipData(data)

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const getSwipData1 = async (Id: any) => {
    setSwipModal2(true);
    try {

      const collectData = {
        "issueId": Id, "indentId": -1, "empId": -1
      };


      const response = await api.post(
        `StaffItemIssue/GetItemIssue`, collectData
      );
      const data = response.data.data[0]?.itemIssueDetail;

      setSwipData2(data)

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const formik = useFormik({
    initialValues: {

      "zoneId": -1,
      "wordId": -1,
      fromDate: null,
      toDate: null,
      poleNo: "",
      "wordId1": -1,
      fromDate1: null,
      toDate1: null,
      compStatusId: -1,
      "empId": -1,
      "zoneId2": -1,
      "wordId2": -1,
      "complaintNo": "",
      "fromDate2": null,
      "toDate2": null,
      "empId3": -1,
      "fromDate3": null,
      "toDate3": null,
      IndentId: -1,

      zoneId4: -1,
      wordId4: -1,
      poleId: -1,
      deviceNo: "",
      simNo: "",
      simContactNo: "",
      relayNo: ""



    },
    // validationSchema: validationSchema,
    onSubmit: async (values) => {

    },
  });







  const fetchZonesData = async () => {
    try {
      const collectData = {
        poleInstId: -1,
        zoneId: formik.values.zoneId,
        wardId: formik.values.wordId,
        "show": true,
        "exportOption": "",
        "fromDate": formik.values.fromDate,
        "toDate": formik.values.toDate
      };
      const response = await api.post(`PoleInstallation/GetPoleInstallation`, collectData);
      const data = response.data.data;
      // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.poleInstId,
        wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [


          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: .5,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,
            renderCell: (params) => {
              return (
                <div
                  style={{ cursor: 'pointer', color: "blue" }}
                  onClick={() => getSwipDataPole(params.row.id)}
                >
                  {params.value}
                </div>
              );
            },
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "wardWithNumber",
            headerName: t("text.wardName"),
            flex: 1,
          },

          {
            field: "poleInstdate",
            headerName: t("text.InstallationDate"),
            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "map",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Map"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >




                  <LocationOnIcon
                    style={{
                      fontSize: "20px",
                      color: "#65b7c9",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      MapData(params.row.id);
                    }}
                  />
                </Stack>,
              ];
            },
          },



        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));



  const fetchZonesData1 = async () => {
    try {
      const collectData = {
        "compId": -1,
        "empId": formik.values.empId,
        "zoneid": formik.values.zoneId2,
        "wardid": formik.values.wordId2,
        "compTypeId": -1,
        "complaintNo": formik.values.complaintNo,
        "fromDate": formik.values.fromDate2,
        "toDate": formik.values.toDate2,
        "compStatusId": formik.values.compStatusId,
        "show": true,
        "exportOption": ".pdf"
      };
      const response = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
      const data = response.data.data;
      // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.compId,
        wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
      }));
      setZones2(zonesWithIds);
      setIsLoading2(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [


          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "compTypeName",
            headerName: t("text.ComplaintType"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "wardWithNumber",
            headerName: t("text.wardName"),
            flex: 1,
          },

          {
            field: "complaintDate",
            headerName: t("text.ComplaintDate"),
            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "empName",
            headerName: t("text.EmployeeName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "complaintNo",
            headerName: t("text.ComplaintNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "complaint",
            headerName: t("text.ComplaintDescription"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "compStatusName",
            headerName: t("text.ComplaintStatus"),
            flex: 1,

            headerClassName: "MuiDataGrid-colCell",
          },


        ];
        setColumns2(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns2 = columns2.map((column: any) => ({
    ...column,
  }));






  const fetchZonesData4 = async () => {
    try {
      const collectData = {
        //itemMasterId: -1,
        "deviceId": -1,
        "deviceNo": formik.values.deviceNo,
        "simNo": "",
        "simContactNo": "",
        "relayNo": "",
        "zoneId": formik.values.zoneId4,
        "wardId": formik.values.wordId4,
        "poleId": formik.values.poleId,
      };
      const response = await api.post(
        `DeviceInstallation/GetDeviceInstallation`,
        collectData
      );
      const data = response.data.data;
      console.log(
        "🚀 ~ fetchZonesData ~ response.data.data:",
        response.data.data
      );
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.deviceId,
        wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
      }));
      setZones4(zonesWithIds);
      setIsLoading4(false);

      if (data.length > 0) {
        const columns4: GridColDef[] = [


          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: .5,
          },


          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,

          },
          {
            field: "wardWithNumber",
            headerName: t("text.wardName"),
            flex: 1,

          },
          {
            field: "poleNo",
            headerName: t("text.PoleNo"),
            flex: 1,

          },

          {
            field: "deviceName",
            headerName: t("text.devivename"),
            flex: 1,

          },
          {
            field: "deviceNo",
            headerName: t("text.deviceno"),
            flex: 1,

          },
          {
            field: "simNo",
            headerName: t("text.simno"),
            flex: 1,

          },

          {
            field: "simContactNo",
            headerName: t("text.simContactNo"),
            flex: 1,

          },
          {
            field: "relayNo",
            headerName: t("text.relayNo"),
            flex: 1,

          },


        ];
        setColumns4(columns4 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns4 = columns4.map((column: any) => ({
    ...column,
  }));






  const fetchZonesData3 = async () => {
    try {
      const collectData = {
        "issueId": -1,
        "indentId": formik.values.IndentId,
        "empId": formik.values.empId3,
        "fromDate": formik.values.fromDate3,
        "toDate": formik.values.toDate3
      };
      const response = await api.post(`StaffItemIssue/GetItemIssue`, collectData);
      const data = response.data.data;
      // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.issueId,
      }));
      setZones3(zonesWithIds);
      setIsLoading3(false);

      if (data.length > 0) {
        const columns3: GridColDef[] = [


          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: .5,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "indentNo",
            headerName: t("text.IndentNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => {
              return (
                <div
                  style={{ cursor: 'pointer', color: "blue" }}
                  onClick={() => getSwipData1(params.row.id)}
                >
                  {params.value}
                </div>
              );
            },
          },
          {
            field: "issueDate",
            headerName: t("text.IssueDate"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
            valueFormatter: (params) => {
              const date = new Date(params.value);
              return date ? format(date, 'dd-MM-yyyy') : '__';
            },
          },

          {
            field: "empName",
            headerName: t("text.EmployeeName"),

            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },


          // {
          //   field: "storeName",
          //   headerName: t("text.StoreName"),

          //   flex: 1,
          //   // headerClassName: "MuiDataGrid-colCell",
          // },


        ];
        setColumns3(columns3 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns3 = columns3.map((column: any) => ({
    ...column,
  }));







  useEffect(() => {

    getZoneData();

    getCount();
    getDepartmentData();
  }, []);



  const getCount = () => {


    api.get(`Dashboard/GetTotalPoleInstallCount?poleInstId=-1`)
      .then((res) => {



        setTotalCount(res.data.totalCount);


      });


    api.get(`Dashboard/TotalComplaintCount?CompId=-1`)
      .then((res) => {


        setComplainCount(res.data.totalCount);


      });


    api.get(`Dashboard/TotalItemIssue?IssueId=-1`)
      .then((res) => {


        setIssueCount(res.data.totalCount);


      });




  };




  const getDepartmentData = () => {
    const collectData = {

      "dept_id": -1,
      "dept_name": "",
      "user_id": "",
      "inst_ID": 0
    };

    api
      .post(
        `Department/GetDepartmentmaster`,
        collectData
      )
      .then((res) => {
        console.log("chekDepartment Data", res.data.data);
        setDepartmentData(res.data.data);
        setSelectedDepartment(res.data.data[0]?.dept_name);
        // setDefaultYear(res.data.data[0]["session_year"]);
        //console.log("fyear", defaultYear);
      });
  };

  const DepartData = DepartmentData.map((session_year, dept_name) => [
    session_year,
    dept_name,

  ]);














  const getZoneData = () => {

    api
      .get(`Dashboard/ZoneWisePoleInstallation`)
      .then((res) => {
        const data = res.data.data

        const formatedData = data
          // .filter((item: any) => item.poleCount > 0)
          .map((item: any) => ({
            value: item.zoneID,
            label: item.zoneName,
            poleCount: item?.poleCount,
            zoneID: item.zoneID,
          }));


        setChartData(formatedData);
        console.log('Check', data)
      });
  };










  return (
    <div

    >
      <Grid
        container
        spacing={2}
        style={{
          // backgroundColor:'red',
          marginTop: "2vh",
        }}
      >

        <ToastContainer />
        <Grid xs={12} sm={6} md={3} item>
          <Card
            className="click"
            elevation={4}
            style={{
              marginLeft: "3%",
              borderRadius: "12px",
              backgroundColor: "#E3F988", // Green, representing energy-efficient poles
              height: "100px", // Keep height consistent
              transition: "all 0.3s ease-in-out",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}


            onClick={() => {
              fetchZonesData();
              setModal(true)
            }}




          >
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
              }}


            >
              <Typography
                variant="h6"
                fontWeight={600}
                color="#3D0C02"
                style={{
                  marginBottom: "5px",
                  letterSpacing: "0.5px",

                }}

              >
                Pole Installed
              </Typography>
              {/* <Typography
                variant="h4"
                color="#3D0C02"
                style={{
                  fontWeight: 700,
                  fontSize: "1.5rem",
                }}
              >
                {/* {TotalCount} 

                <AnimatedCount totalCount={TotalCount} />
              </Typography> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  border: "1px solid #3D0C02",
                }}
              >
                <Typography
                  variant="h4"
                  color="#3D0C02"
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  {/* {ComplainCount}  */}
                  <AnimatedCount totalCount={TotalCount} />
                </Typography>
              </div>

            </CardContent>
          </Card>
        </Grid>

        {/* Street Light Status Card */}
        <Grid xs={12} sm={6} md={3} item>
          <Card
            className="click"
            elevation={4}
            style={{
              marginLeft: "3%",
              borderRadius: "12px",
              backgroundColor: "#B2FFFF", // Red for attention-grabbing light status
              height: "100px", // Keep height consistent
              transition: "all 0.3s ease-in-out",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}

            onClick={() => {
              fetchZonesData1();
              setModal2(true)
            }}

          >
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                color="#3D0C02"
                style={{
                  marginBottom: "5px",
                  letterSpacing: "0.5px",
                }}
              >
                Complaints
              </Typography>
              {/* <Typography
                variant="h4"
                color="#3D0C02"
                style={{
                  fontWeight: 700,
                  fontSize: "1.5rem",
                }}
              >
                {/* {ComplainCount}  

                <AnimatedCount totalCount={ComplainCount} />
              </Typography> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  border: "1px solid #3D0C02",
                }}
              >
                <Typography
                  variant="h4"
                  color="#3D0C02"
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  {/* {ComplainCount}  */}
                  <AnimatedCount totalCount={ComplainCount} />
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>


        <Grid xs={12} sm={6} md={3} item>
          <Card
            className="click"
            elevation={4}
            style={{
              marginLeft: "3%",
              borderRadius: "12px",
              backgroundColor: "#FED8B1",
              height: "100px",
              transition: "all 0.3s ease-in-out",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}

            onClick={() => {
              fetchZonesData3();
              setModal3(true)
            }}
          >
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                color="#3D0C02"
                style={{
                  marginBottom: "5px",
                  letterSpacing: "0.5px",
                }}
              >
                Material Issued
              </Typography>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  border: "1px solid #3D0C02",
                }}
              >
                <Typography
                  variant="h4"
                  color="#3D0C02"
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  {/* {ComplainCount}  */}
                  <AnimatedCount totalCount={IssueCount} />
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>


        <Grid xs={12} sm={6} md={3} item>
          <Card
            className="click"
            elevation={4}
            style={{
              marginLeft: "3%",
              borderRadius: "12px",
              backgroundColor: "#7fd4d2",
              height: "100px",
              transition: "all 0.3s ease-in-out",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}

            onClick={() => {
              fetchZonesData4();
              setModal4(true)
            }}
          >
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                color="#3D0C02"
                style={{
                  marginBottom: "5px",
                  letterSpacing: "0.5px",
                }}
              >
                Device Installed
              </Typography>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  border: "1px solid #3D0C02",
                }}
              >
                <Typography
                  variant="h4"
                  color="#3D0C02"
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  {/* {ComplainCount}  */}
                  <AnimatedCount totalCount={deviceCount} />
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>




        <Divider />



        <Grid xs={12} sm={6} md={6} item>
          <Card
            elevation={4}
            style={{
              marginLeft: "1%",
              borderRadius: "12px",
              background: "#fff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0px 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0px 4px 8px rgba(0, 0, 0, 0.1)";
            }}
          >
            <Grid
              style={{
                width: "100%",
                height: "50vh",
                backgroundColor: "#f3f4f7",
                borderRadius: "10px 10px 0 0",
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  padding: "20px",
                  background: "linear-gradient(to right, #7fd1eb, #5c6bc0)",
                  color: "#fff",
                  borderRadius: "10px 10px 0 0",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                }}
              >
                Zone Distribution
              </Typography>


              <Chart
                width={"100%"}
                height={"90%"}
                chartType="PieChart"
                data={[
                  ["Zone", "Pole Count"],
                  ...chartData.map((item: any) => [item.label, item.poleCount]), // map chartData to the format that PieChart expects
                ]}
                options={{
                  chartArea: { left: 15, top: 15, right: 80, bottom: 15 },
                  legend: { position: "left" },
                  pieSliceText: 'label',
                }}
                chartEvents={[
                  {
                    eventName: "select",
                    callback: ({ chartWrapper }) => {
                      const chart = chartWrapper.getChart();
                      const selection = chart.getSelection();

                      if (selection.length > 0) {
                        const item = selection[0]; // Get selected item
                        const clickedData = chartData[item.row]; // Access the clicked data
                        console.log("Clicked Item Data:", clickedData);

                        if (clickedData?.zoneID) {
                          zoneStatusData(clickedData.zoneID);
                          getWardData(clickedData.zoneID);
                        } else {
                          console.warn("zoneID not found for clicked item");
                        }
                      }
                    },
                  },
                ]}
              />

            </Grid>
          </Card>
        </Grid>

        {/* LineChart Card */}
        <Grid xs={12} sm={6} md={6} item>
          <Card
            elevation={4}
            style={{
              marginLeft: "0.5%",
              borderRadius: "12px",
              background: "#fff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0px 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0px 4px 8px rgba(0, 0, 0, 0.1)";
            }}
          >
            <Grid
              style={{
                width: "100%",
                height: "50vh",
                backgroundColor: "#f3f4f7",
                borderRadius: "10px 10px 0 0",
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  padding: "20px",
                  background: "linear-gradient(to right, #7fd1eb, #5c6bc0)",
                  color: "#fff",
                  borderRadius: "10px 10px 0 0",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                }}
              >
                Complaint Status

              </Typography>



              <div style={{ margin: "2%" }}>
                {/* Pending Status */}
                <Typography
                  variant="body1"
                  style={{
                    color: "#4CAF50",
                    fontWeight: 600,
                    cursor: "pointer",
                    marginBottom: "8px",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    fetchCompStatus(2);
                  }}
                >
                  Pending: <AnimatedCount totalCount={IsPending} />
                </Typography>
                <ProgressBar
                  completed={Math.round((IsPending / IsTotal) * 100) || 0}
                  bgColor="#4CAF50"
                  height="24px"
                  labelAlignment="outside"
                  labelColor="black"
                />

                {/* Processing Status */}
                <Typography
                  variant="body1"
                  style={{
                    color: "#FF9800",
                    fontWeight: 600,
                    cursor: "pointer",
                    marginTop: "20px",
                    marginBottom: "8px",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    fetchCompStatus(3);
                  }}
                >
                  Processing: {<AnimatedCount totalCount={IsProcceccing} />}
                </Typography>
                <ProgressBar
                  completed={Math.round((IsProcceccing / IsTotal) * 100) || 0}
                  bgColor="#FF9800"
                  height="24px"
                  labelAlignment="outside"
                  labelColor="black"
                />

                {/* Completed Status */}
                <Typography
                  variant="body1"
                  style={{
                    color: "#F44336",
                    fontWeight: 600,
                    cursor: "pointer",
                    marginTop: "20px",
                    marginBottom: "8px",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    fetchCompStatus(1);
                  }}
                >
                  Completed: {<AnimatedCount totalCount={IsComplete} />}
                </Typography>
                <ProgressBar
                  completed={Math.round((IsComplete / IsTotal) * 100) || 0}
                  bgColor="#F44336"
                  height="24px"
                  labelAlignment="outside"
                  labelColor="black"
                />
              </div>
              {/* <Chart
                chartType="LineChart"
                width="100%"
                height="88%"
                data={chartData1}
                options={options}
              /> */}
            </Grid>
          </Card>
        </Grid>


        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal1}
            onClose={handleClose1}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Zone:{" "}
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={handleClose1}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}
            >


              <IconButton
                onClick={handleCollapse2}
                style={{
                  backgroundColor: openCollaps2 ? "#ff9822" : "#2196f3",
                  color: "#fff",
                  marginTop: "5px",
                }}
              >

                <FilterAltOutlinedIcon />

              </IconButton>
              <strong style={{ marginLeft: "2px", textDecoration: "underline" }}>
                Filters
              </strong>
              <Collapse in={openCollaps2}>



                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  sx={{ marginTop: "1%" }}
                >

                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={taxOption}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("wordId1", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                        getPole(newValue?.value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectWard")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Option1}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        //console.log(newValue?.value);

                        //formik.setFieldValue("wordId", newValue?.value);
                        formik.setFieldValue("poleNo", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectPole")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={3} lg={3} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.FromDate")} />}
                      value={formik.values.fromDate1}
                      name="fromDate1"
                      id="fromDate1"
                      placeholder={t("text.FromDate")}
                      size="small"
                      fullWidth
                      type="date"
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={3} lg={3} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.ToDate")} />}
                      value={formik.values.toDate1}
                      name="toDate1"
                      id="toDate1"
                      placeholder={t("text.ToDate")}
                      type="date"
                      size="small"
                      fullWidth
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={4} lg={4} xs={12}></Grid>

                  <Grid item xs={12} lg={4}>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth={true}
                      style={{
                        // width: "60%",

                        backgroundColor: `var(--header-background)`,
                        //margin: "1%",
                      }}
                      onClick={() => {
                        zoneStatusData(zones5[0]?.zoneId);

                      }}
                    >
                      {t("text.show")}
                    </Button>


                  </Grid>
                </Grid>

              </Collapse>





              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading5 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones5 && zones5.length > 0 ? (
                        <DataGrid
                          rows={zones5}
                          columns={adjustedColumns5}
                          rowSpacingType="border"
                          autoHeight={false}
                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div> // Message when no data is present
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>



        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal}
            onClose={() => setModal(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Pole Installed
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={() => setModal(false)}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}
            >


              <IconButton
                onClick={handleCollapse}
                style={{
                  backgroundColor: openCollaps ? "#ff9822" : "#2196f3",
                  color: "#fff",
                  marginTop: "5px",
                }}
              >

                <FilterAltOutlinedIcon />

              </IconButton>
              <strong style={{ marginLeft: "2px", textDecoration: "underline" }}>
                Filters
              </strong>
              <Collapse in={openCollaps}>

                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  sx={{ marginTop: "1%" }}
                >
                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Option}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("zoneId", newValue?.value);
                        // formik.setFieldValue("zoneName", newValue?.label);
                        getWardData(newValue?.value)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectZone")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />

                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={taxOption}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("wordId", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectWard")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.FromDate")} />}
                      value={formik.values.fromDate}
                      name="fromDate"
                      id="fromDate"
                      placeholder={t("text.FromDate")}
                      size="small"
                      fullWidth
                      type="date"
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={4} lg={4} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.ToDate")} />}
                      value={formik.values.toDate}
                      name="toDate"
                      id="toDate"
                      placeholder={t("text.ToDate")}
                      type="date"
                      size="small"
                      fullWidth
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>




                  <Grid item xs={12} lg={4}>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth={true}
                      style={{
                        // width: "60%",

                        backgroundColor: `var(--header-background)`,
                        //margin: "1%",
                      }}
                      onClick={() => {
                        fetchZonesData();

                      }}
                    >
                      {t("text.show")}
                    </Button>


                  </Grid>
                </Grid>


              </Collapse>
              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones && zones.length > 0 ? (
                        <DataGrid
                          rows={zones}
                          columns={adjustedColumns}
                          rowSpacingType="border"
                          autoHeight={false}
                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>




        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal2}
            onClose={() => setModal2(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Complaints
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={() => setModal2(false)}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}

            >

              <IconButton
                onClick={handleCollapse1}
                style={{
                  backgroundColor: openCollaps1 ? "#ff9822" : "#2196f3",
                  color: "#fff",
                  marginTop: "5px",
                }}
              >

                <FilterAltOutlinedIcon />

              </IconButton>
              <strong style={{ marginLeft: "2px", textDecoration: "underline" }}>
                Filters
              </strong>
              <Collapse in={openCollaps1}>



                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  sx={{ marginTop: "1%" }}
                >
                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Option}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("zoneId2", newValue?.value);
                        // formik.setFieldValue("zoneName", newValue?.label);
                        getWardData(newValue?.value)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectZone")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />

                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={taxOption}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("wordId2", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectWard")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Iscomplaint}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("complaintNo", newValue?.label);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectComplaintNo")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={IsStatus}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("compStatusId", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.Status")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={IsEmp}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("empId", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectEmployee")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={4} lg={4} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.FromDate")} />}
                      value={formik.values.fromDate2}
                      name="fromDate2"
                      id="fromDate2"
                      placeholder={t("text.FromDate")}
                      size="small"
                      fullWidth
                      type="date"
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={4} lg={4} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.ToDate")} />}
                      value={formik.values.toDate2}
                      name="toDate2"
                      id="toDate2"
                      placeholder={t("text.ToDate")}
                      type="date"
                      size="small"
                      fullWidth
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>




                  <Grid item xs={12} lg={4}>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth={true}
                      style={{
                        // width: "60%",

                        backgroundColor: `var(--header-background)`,
                        //margin: "1%",
                      }}
                      onClick={() => {
                        fetchZonesData1();

                      }}
                    >
                      {t("text.show")}
                    </Button>


                  </Grid>
                </Grid>


              </Collapse>




              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading2 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones2 && zones2.length > 0 ? (
                        <DataGrid
                          rows={zones2}
                          columns={adjustedColumns2}
                          rowSpacingType="border"
                          autoHeight={false}
                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div> // Message when no data is present
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>




        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal6}
            onClose={() => setModal6(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Complaints
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={() => setModal6(false)}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}

            >



              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading6 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones6 && zones6.length > 0 ? (
                        <DataGrid
                          rows={zones6}
                          columns={adjustedColumns6}
                          rowSpacingType="border"
                          autoHeight={false}
                          slots={{
                            toolbar: GridToolbar,
                          }}

                          slotProps={{
                            toolbar: {
                              showQuickFilter: true,
                            },
                          }}



                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div> // Message when no data is present
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>





        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal3}
            onClose={() => setModal3(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Material Issued Item
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={() => setModal3(false)}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}
            >


              <IconButton
                onClick={handleCollapse3}
                style={{
                  backgroundColor: openCollaps3 ? "#ff9822" : "#2196f3",
                  color: "#fff",
                  marginTop: "5px",
                }}
              >

                <FilterAltOutlinedIcon />

              </IconButton>
              <strong style={{ marginLeft: "2px", textDecoration: "underline" }}>
                Filters
              </strong>
              <Collapse in={openCollaps3}>



                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  sx={{ marginTop: "1%" }}
                >


                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={IsEmp}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("empId3", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectEmployee")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={IsIndentNo}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("IndentId", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectIndent")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>



                  <Grid item sm={3} lg={3} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.FromDate")} />}
                      value={formik.values.fromDate3}
                      name="fromDate3"
                      id="fromDate3"
                      placeholder={t("text.FromDate")}
                      size="small"
                      fullWidth
                      type="date"
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={3} lg={3} xs={12}>
                    <TextField
                      label={<CustomLabel text={t("text.ToDate")} />}
                      value={formik.values.toDate3}
                      name="toDate3"
                      id="toDate3"
                      placeholder={t("text.ToDate")}
                      type="date"
                      size="small"
                      fullWidth
                      style={{ backgroundColor: "white" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} lg={4}></Grid>




                  <Grid item xs={12} lg={4}>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth={true}
                      style={{
                        // width: "60%",

                        backgroundColor: `var(--header-background)`,
                        //margin: "1%",
                      }}
                      onClick={() => {
                        fetchZonesData3();

                      }}
                    >
                      {t("text.show")}
                    </Button>


                  </Grid>
                </Grid>


              </Collapse>






              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading3 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones3 && zones3.length > 0 ? (
                        <DataGrid
                          rows={zones3}
                          columns={adjustedColumns3}
                          rowSpacingType="border"
                          autoHeight={false}
                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div> // Message when no data is present
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>




        <Grid xs={12} lg={12} sm={12} item>
          <Dialog
            open={isModal4}
            onClose={() => setModal4(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialogContent-root": {
                padding: "20px",
                height: "400px",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
              }}
            >
              <Typography variant="h6" style={{ color: "#ffff" }}>
                Total Device Installed
                <span style={{ color: "#474d54", fontWeight: "bold" }}>
                  {/* {isStatus} */}
                </span>
              </Typography>
              <IconButton
                edge="end"
                onClick={() => setModal4(false)}
                sx={{
                  color: `var(--grid-headerColor)`,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "20px",
                height: "400px",
                overflow: "hidden",
              }}
            >



              <IconButton
                onClick={handleCollapse4}
                style={{
                  backgroundColor: openCollaps4 ? "#ff9822" : "#2196f3",
                  color: "#fff",
                  marginTop: "5px",
                }}
              >

                <FilterAltOutlinedIcon />

              </IconButton>
              <strong style={{ marginLeft: "2px", textDecoration: "underline" }}>
                Filters
              </strong>
              <Collapse in={openCollaps4}>



                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  sx={{ marginTop: "1%" }}
                >


                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Option}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("zoneId4", newValue?.value);
                        // formik.setFieldValue("zoneName", newValue?.label);
                        getWardData(newValue?.value)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectZone")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />

                  </Grid>


                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={taxOption}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("wordId4", newValue?.value);
                        //formik.setFieldValue("wardName", newValue?.label);
                        getPole(newValue?.value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectWard")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={Option1}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        //console.log(newValue?.value);

                        formik.setFieldValue("poleId", newValue?.value);
                        //formik.setFieldValue("poleNo", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectPole")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>


                  <Grid item sm={3} lg={3} xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={IsDeviceNo}
                      //   value={
                      //     Option.find(
                      //       (option: any) => option.value === formik.values.stateId
                      //     ) || null
                      //   }
                      fullWidth
                      size="small"
                      onChange={(event, newValue: any) => {
                        console.log(newValue?.value);

                        // formik.setFieldValue("compStatusId", newValue?.value);
                        formik.setFieldValue("deviceNo", newValue?.label);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <CustomLabel
                              text={t("text.SelectDeviceNo")}
                              required={false}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} lg={4}></Grid>




                  <Grid item xs={12} lg={4}>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth={true}
                      style={{
                        // width: "60%",

                        backgroundColor: `var(--header-background)`,
                        //margin: "1%",
                      }}
                      onClick={() => {
                        fetchZonesData4();

                      }}
                    >
                      {t("text.show")}
                    </Button>


                  </Grid>
                </Grid>


              </Collapse>







              <Grid
                item
                xs={12}
                container
                spacing={2}
                sx={{ marginTop: "1%" }}
              >
                <Grid item sm={12} lg={12} xs={12}>
                  {isLoading4 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {zones4 && zones4.length > 0 ? (
                        <DataGrid
                          rows={zones4}
                          columns={adjustedColumns4}
                          rowSpacingType="border"
                          autoHeight={false}
                          sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: `var(--grid-headerBackground)`,
                              color: `var(--grid-headerColor)`,
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                              color: "white",
                            },
                            "& .MuiDataGrid-cell": {
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            },
                            height: 400,
                            overflowY: "auto",
                          }}
                        />
                      ) : (
                        <div>No data found</div> // Message when no data is present
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>



        <Grid xs={12} lg={12} sm={12} item>
          <Drawer
            anchor="right"
            style={{ zIndex: 1400 }}
            open={swipModal}
            onClose={() => setSwipModal(false)}
          >
            {/* Drawer content */}
            <div style={{ width: '700px', padding: '20px', backgroundColor: '#f4f7fc' }}>
              {/* Header with color */}
              <div
                style={{
                  backgroundColor: '#1976D2', // Blue color for header
                  color: '#fff',
                  padding: '15px 20px',
                  borderRadius: '8px 8px 0 0',
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                Pole Installed Item Details
              </div>

              {/* Table container with better padding and spacing */}
              <TableContainer style={{ marginTop: '20px' }}>
                <Table style={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd', // Light blue for header background
                          fontWeight: 'bold',
                          color: '#1976D2', // Blue text color
                          textAlign: 'center',
                          whiteSpace: 'nowrap', // Prevent text wrapping in header
                        }}
                      >
                        Poleno
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Install of Light
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Latitude
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Longitude
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Depth
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Image
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Employee Name
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {swipData.map((item: any) => (
                      <TableRow key={item.poleInstChildId}>
                        <TableCell style={{ textAlign: 'left' }}>{item.poleno}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                          {item.installOfLight}
                        </TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{item.latitute}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{item.longitute}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{item.depth}</TableCell>

                        <TableCell>
                          <img
                            src={item.poleimg}
                            alt={`Pole Image ${item.poleInstChildId}`}
                            style={{ width: '50px', height: '50px', borderRadius: '8px' }}
                          />
                        </TableCell>
                        <TableCell style={{ textAlign: 'left' }}>{item.empName}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Drawer>
        </Grid>


        <Grid xs={12} lg={12} sm={12} item>
          <Drawer
            anchor="right"
            style={{ zIndex: 1400 }}
            open={swipModal1}
            onClose={() => setSwipModal1(false)}
          >
            {/* Drawer content */}
            <div style={{ width: '700px', padding: '20px', backgroundColor: '#f4f7fc' }}>
              {/* Header with color */}
              <div
                style={{
                  backgroundColor: '#1976D2', // Blue color for header
                  color: '#fff',
                  padding: '15px 20px',
                  borderRadius: '8px 8px 0 0',
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                Zone wise Pole Item Details
              </div>

              {/* Table container with better padding and spacing */}
              <TableContainer style={{ marginTop: '20px' }}>
                <Table style={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>

                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Switch
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd', // Light blue for header background
                          fontWeight: 'bold',
                          color: '#1976D2', // Blue text color
                          textAlign: 'center',
                          whiteSpace: 'nowrap', // Prevent text wrapping in header
                        }}
                      >
                        Item Name
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Light Number
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Watt
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        On/Off
                      </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {swipData1.map((item: any) => (
                      <TableRow key={item.lightInstallationId}>


                        <TableCell style={{ textAlign: 'center' }}>
                          <Switch
                            checked={item.isOn === true}
                            style={{
                              color: item.isOn === true ? 'green' : 'red',
                            }}
                            onChange={(event: any) => handleSwitchChange(event, item, isData[0]?.lightInstId)}
                            inputProps={{
                              "aria-label": "Toggle Switch",
                            }}
                          /></TableCell>


                        <TableCell style={{ textAlign: 'center' }}>{item.itemName}</TableCell>

                        <TableCell style={{ textAlign: 'center' }}>{item.lightNo}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>{item.walt}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>
                          <img
                            src={item.isOn ? lightOn : lightOff}
                            alt={item.isOn ? "Light On" : "Light Off"}
                            style={{ width: item.isOn ? 40 : 30, height: item.isOn ? 40 : 30 }}
                          />
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Drawer>
        </Grid>



        <Grid xs={12} lg={12} sm={12} item>
          <Drawer
            anchor="right"
            style={{ zIndex: 1400 }}
            open={swipModal2}
            onClose={() => setSwipModal2(false)}
          >
            {/* Drawer content */}
            <div style={{ width: '700px', padding: '20px', backgroundColor: '#f4f7fc' }}>
              {/* Header with color */}
              <div
                style={{
                  backgroundColor: '#1976D2', // Blue color for header
                  color: '#fff',
                  padding: '15px 20px',
                  borderRadius: '8px 8px 0 0',
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                Material Issue Item Details
              </div>

              {/* Table container with better padding and spacing */}
              <TableContainer style={{ marginTop: '20px' }}>
                <Table style={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd', // Light blue for header background
                          fontWeight: 'bold',
                          color: '#1976D2', // Blue text color
                          textAlign: 'center',
                          whiteSpace: 'nowrap', // Prevent text wrapping in header
                        }}
                      >
                        Item Name
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Unit Name
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Request Quantity
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Issue Quantity
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold',
                          color: '#1976D2',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Pending Quantity
                      </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {swipData2.map((item: any) => (
                      <TableRow key={item.id}>
                        <TableCell style={{ textAlign: 'center' }}>{item.itemName}</TableCell>

                        <TableCell style={{ textAlign: 'center' }}>{item.unitName}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>{item.reqQty}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>
                          {item.issueQty}
                        </TableCell>

                        <TableCell style={{ textAlign: 'center' }}>{item.stockQty}</TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Drawer>
        </Grid>



        <Modal open={currentMap} onClose={() => setCurrentMap(false)}>
          <Box sx={style}>
            {currentMap && (
              <Grid item xs={12} sm={12} lg={12}>
                {/* {isLoading1 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      ) : ( */}
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={70} // Default zoom, will be adjusted by `fitBounds`
                  onLoad={(map: any) => (mapRef.current = map)}
                >
                  {vehicles.map((vehicle: any) => (
                    <Marker
                      key={vehicle.id}
                      position={{
                        lat: vehicle.lat,
                        lng: vehicle.lng,
                      }}
                      icon={{
                        url: vehicle.icon,
                        scaledSize: new window.google.maps.Size(
                          50,
                          50
                        ),
                        origin: new window.google.maps.Point(0, 0),
                        anchor: new window.google.maps.Point(25, 25),
                      }}
                      onMouseOver={() =>
                        handleMarkerMouseOver(vehicle)
                      } // Show vehicle number on hover
                      onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
                    >
                      {activeVehicle &&
                        activeVehicle.id === vehicle.id && (
                          <InfoWindow>
                            <div>
                              <div>
                                <strong>Zone Name: </strong>
                                {vehicle.zoneName}
                              </div>

                              <div>
                                <strong>Ward Name: </strong>
                                {vehicle.wardName}
                              </div>

                              <div>
                                <strong>Depth: </strong>
                                {vehicle.depth}
                              </div>

                              <div>
                                <strong>Pole No: </strong>
                                {vehicle.poleno}
                              </div>

                              <div>
                                <strong>Date : </strong>
                                {vehicle.tracktime}
                              </div>
                            </div>
                          </InfoWindow>
                        )}
                    </Marker>
                  ))}
                </GoogleMap>
                {/* )} */}
              </Grid>
            )}
          </Box>
        </Modal>









      </Grid>
    </div>
  );
}

// export class WeightChart {
//   sDate: string = "";
//   weight: number = 0;
//   nooftrip: number = 0;
// }
